import { createTheme } from "@mui/material/styles";

// Mirrors BloomABA's theme (BloomABA/frontend/src/app/theme.ts) so the Cortica
// apps share one look. Keep the two in sync when either changes.
export const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#10389a",
      light: "#e8f0fc",
      contrastText: "#fcfcfc",
    },
    success: {
      main: "#2e7d32",
    },
    warning: {
      main: "#ff9800",
    },
    background: {
      // Matches Bloom's main content background (grey[100])
      default: "#f5f5f5",
      paper: "#ffffff",
    },
    text: {
      primary: "#121212",
      secondary: "rgba(18, 18, 18, 0.6)",
      disabled: "rgba(0, 0, 0, 0.38)",
    },
    divider: "rgba(0, 0, 0, 0.12)",
  },
  typography: {
    fontFamily: "Roboto, sans-serif",
    h5: {
      fontSize: 24,
      fontWeight: 400,
      lineHeight: 1.334,
      letterSpacing: 0,
    },
    subtitle1: {
      fontSize: 16,
      fontWeight: 400,
      lineHeight: 1.75,
      letterSpacing: 0.15,
    },
    body1: {
      fontSize: 16,
      fontWeight: 400,
      lineHeight: 1.5,
      letterSpacing: 0.15,
    },
    body2: {
      fontSize: 14,
      fontWeight: 400,
      lineHeight: 1.43,
      letterSpacing: 0.17,
    },
    caption: {
      fontSize: 12,
      fontWeight: 400,
      lineHeight: 1.66,
      letterSpacing: 0.4,
    },
  },
  shape: {
    borderRadius: 4,
  },
  components: {
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        colorSuccess: {
          backgroundColor: "#E4F2E5",
          color: "#2E7D32",
        },
        colorWarning: {
          backgroundColor: "#FFE4CC",
          color: "#E65100",
        },
      },
    },
  },
});

export default theme;
